import { render, staticRenderFns } from "./MarksMean.vue?vue&type=template&id=05a91998"
import script from "./MarksMean.vue?vue&type=script&lang=js"
export * from "./MarksMean.vue?vue&type=script&lang=js"
import style0 from "./MarksMean.vue?vue&type=style&index=0&id=05a91998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports